<template>
  <v-app-bar app :color="color" dense dark>
    <v-toolbar-title>goPuff Reporting</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu left bottom v-if="isAuthenticated">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" data-qa-menu>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item data-testid="vlistItem"
          v-for="(item, n) in items"
          :key="n"
          @click="handleSignOut"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: 'Header',
  data: () => ({
    item: 1,
    items: [
      { text: 'Sign Out', icon: 'mdi-power' }
    ],
    error: false,
    color: '#109dce',
    timeout: 6000
  }),
  computed: {
    isAuthenticated () {
      return !!this.$adal.isAuthenticated()
    }
  },
  methods: {
    handleSignOut () {
      this.$adal.logout()
    }
  }
}
</script>
